export enum BrandTab {
  all = 'all',
  favorites = 'favorites',
}
